var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.598247,
    y: 0.418803,
    width: 29.1624,
    height: 29.1624,
    rx: 2.93162,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.598247,
    y: 0.418803,
    width: 29.1624,
    height: 29.1624,
    rx: 2.93162,
    stroke: "#E5E7EB",
    strokeWidth: 0.837607
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5221 11.3281C16.3006 11.0804 14.0584 11.0804 11.8369 11.3281C11.8028 11.332 11.7705 11.345 11.7431 11.3657C11.7158 11.3864 11.6945 11.414 11.6815 11.4458C11.6685 11.4775 11.6642 11.5121 11.6692 11.546C11.6741 11.5799 11.6881 11.6119 11.7096 11.6386L13.6735 14.0666C14.377 14.9362 14.7607 16.0209 14.7607 17.1395V18.7527L15.5983 19.3669V17.1389C15.5984 16.0205 15.9822 14.9361 16.6855 14.0666L18.6494 11.6386C18.671 11.6119 18.6849 11.5799 18.6898 11.546C18.6948 11.5121 18.6905 11.4775 18.6775 11.4458C18.6645 11.414 18.6432 11.3864 18.6159 11.3657C18.5886 11.345 18.5562 11.332 18.5221 11.3281ZM11.7442 10.4956C14.0275 10.2404 16.3321 10.2404 18.6154 10.4956C19.4228 10.586 19.812 11.5331 19.3011 12.1652L17.3372 14.5931C16.7541 15.3137 16.436 16.2125 16.4359 17.1395V20.1934C16.436 20.2708 16.4146 20.3468 16.374 20.4128C16.3335 20.4788 16.2755 20.5323 16.2064 20.5673C16.1373 20.6023 16.0599 20.6174 15.9827 20.6111C15.9055 20.6047 15.8316 20.5771 15.7692 20.5312L14.094 19.3027C14.041 19.2638 13.9979 19.2129 13.9682 19.1542C13.9385 19.0955 13.9231 19.0307 13.9231 18.9649V17.1389C13.9231 16.2119 13.6048 15.3135 13.0224 14.5926L11.0585 12.1657C10.547 11.5336 10.9356 10.586 11.7442 10.4956Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.03064b00708505326c27d9b5a203414c.svg";
export { ForwardRef as ReactComponent };